<div class="container">
  <div class="content">
    <div class="app-stateful-back-button">
      <app-stateful-internal-link
        [text]="this.backText"
        [pageUrl]="this.backUrl"
      >
      </app-stateful-internal-link>
    </div>
    <div class="center-column">
      <img class="nowaccount-logo" alt="NowAccount Logo" />
      <h1>{{ this.headerText }}</h1>
      <p class="subHeaderText">{{ this.subheaderText }}</p>
      <ng-container [formGroup]="this.form">
        <!-- Password -->
        <app-kendo-password-textbox
          inputText="{{ this.passwordText }}"
          formControlName="password"
          inputType="password"
          [parentForm]="form"
        >
        </app-kendo-password-textbox>
        <!-- Validations for password -->
        <div
          *ngIf="
            this.form.get('password')?.invalid &&
            (this.form.get('password')?.dirty ||
              this.form.get('password')?.touched)
          "
          class="invalid-feedback"
        >
          <div
            *ngIf="this.form.get('password')?.invalid && this.form.get('password')?.errors?.['required']"
          >
            Password is required.
          </div>
        </div>

        <!-- Password strength errors -->
        <kendo-formerror
          *ngIf="
            this.form.get('password')?.touched &&
            this.form.get('password')?.hasError('passwordStrength') &&
            this.form.get('password')?.value.length !== 0
          "
          >Enter a strong password
        </kendo-formerror>

        <!-- Confirm Password -->
        <app-kendo-password-textbox
          inputText="{{ this.confirmpasswordText }}"
          formControlName="confirmpassword"
          inputType="password"
          [parentForm]="form"
        >
        </app-kendo-password-textbox>
        <!-- Validations for confirm password -->
        <div
          *ngIf="
            this.form.get('confirmpassword')?.invalid &&
            (this.form.get('confirmpassword')?.dirty ||
              this.form.get('confirmpassword')?.touched)
          "
          class="invalid-feedback"
        >
          <div
            *ngIf="this.form.get('confirmpassword')?.invalid && this.form.get('confirmpassword')?.errors?.['required']"
          >
            Confirm Password is required.
          </div>
          <div
            *ngIf="
              this.form.get('confirmpassword')?.hasError('passwordMismatch')
            "
          >
            Passwords do not match
          </div>
        </div>
        <!-- 
        <kendo-formerror
          *ngIf="this.form.get('confirmpassword')?.hasError('passwordMismatch')"
          >Passwords do not match</kendo-formerror
        > -->

        <div class="button-wrapper">
          <app-primary-button
            text="{{ this.resetPasswordBtnText }}"
            href=""
            [clickEvent]="this.submitResetPasswordForm.bind(this)"
          >
          </app-primary-button>
        </div>
      </ng-container>
    </div>
  </div>
</div>
